import {JsonObject, JsonProperty} from 'json2typescript';
import {ExternalLinkConverter} from '../customJsonConverters/ExternalLinkConverter';
import {ExternalLink} from './social-sharing/externalLink';

@JsonObject('MediaQuestion')
export class MediaQuestion {

    @JsonProperty('type',String,true)
    type = '';// picture, gif, video, pictures_animation

    @JsonProperty('questionNo',Number,true)
    questionNo = 0;

    @JsonProperty('choiceNo',Number,true)
    choiceNo= 0;

    @JsonProperty('uid',String,true)
    uid = '';

    @JsonProperty('linkToUrl',Boolean,true)
    linkToUrl = false;

    @JsonProperty('linkToMicrosite',Boolean,true)
    linkToMicrosite = false;

    @JsonProperty('externalLink',ExternalLinkConverter,true)
    externalLink = new ExternalLink();

    constructor(typo:string,qNo:number) {
        this.type = typo;
        this.questionNo = qNo;
    }
}
